import { useState } from 'react'
import { toast } from 'react-toastify'
import { postDataWithoutParams } from 'src/consumer/services/featureServices'

/**
 * Hook for uploading File objects to the server
 *
 * @returns {Object} - { uploadImage, isUploading }
 *
 * @example
 * const { uploadImage, isUploading } = useImageUpload()
 *
 * // Upload a file
 * const imageId = await uploadImage(fileObject)
 * if (imageId) {
 *   console.log('Upload successful:', imageId)
 * }
 */
export function useImageUpload() {
  const [isUploading, setIsUploading] = useState(false)

  const uploadImage = async (file) => {
    if (!file) {
      toast.error('No file provided')
      return null
    }

    setIsUploading(true)
    try {
      const formData = new FormData()
      formData.append('file', file)

      const response = await postDataWithoutParams('/api/media/file/upload', formData)

      if (response?.status === 200) {
        const imageId = response.data.fileId
        return imageId
      } else {
        toast.error('Upload failed')
        return null
      }
    } catch (err) {
      toast.error('Something went wrong during upload')
      console.error('Upload error:', err)
      return null
    } finally {
      setIsUploading(false)
    }
  }

  return {
    uploadImage,
    isUploading,
  }
}
